import { Activity } from "@finway-group/shared/lib/models"
import axios from "axios"

const MODEL = "activity"

const ActivityService = {
    fetchActivities: async (page = 1) => {
        const { data } = await axios.get(`/${MODEL}/?page=${page}&sortBy=desc(created)`)
        return {
            ...data,
            docs: data.docs.map((item: any) => new Activity(item)),
        }
    },
    fetchUnseenActivityCount: async () => {
        const {
            data: { totalUnseen },
        } = await axios.get(`/${MODEL}/unseen/count`)
        return totalUnseen
    },
    markAsViewed: async (activity: Activity) => await axios.put(`/${MODEL}/${activity.id}`, activity),
    markAllAsViewed: async () => await axios.put(`/${MODEL}/viewed/markAllAsViewed`),
}

export default ActivityService
